import { cn } from "../../../../lib/utils";
import { SquarePen, X } from "lucide-react";

interface EditToggleButtonProps {
  isEditing: boolean;
  onEdit: () => void;
  onCancel: () => void;
  className?: string;
}

export default function EditToggleButton({
  isEditing,
  onEdit,
  onCancel,
  className
}: EditToggleButtonProps) {
  return (
    <button
      type="button"
      onClick={isEditing ? onCancel : onEdit}
      className={cn("flex items-center justify-center gap-2 rounded-[8px] px-2 py-2 text-xs font-medium leading-4 text-[#171717] bg-transparent border-none shadow-none", className)}
    >
      {isEditing ? (
        <X className="h-4 w-4 text-[#171717]" />
      ) : (
        <SquarePen className="h-4 w-4 text-[#171717]" />
      )}
    </button>
  );
}